import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface DateSelectProps<T = any> {
  name: string;
  value: Date;
  onChange: (option: T) => void;
  minDate?: Date;
  maxDate?: Date;
}

export default function DateSelect<T = any>({
  name,
  value,
  onChange,
  minDate,
  maxDate,
}: DateSelectProps<T>): React.JSX.Element {
  return (
    <DatePicker
      className="width-100"
      selected={value}
      onChange={(date) => onChange({ name, value: date })}
      popperPlacement="bottom-start"
      minDate={minDate}
      maxDate={maxDate}
    />
  );
}
